import { Dtos, WorkInProgressStatementId } from "@inrev/common";

export const updateWipStatementUnderwriterLock = (
	locked: boolean,
	wipStatements: Dtos.Admin.WipStatement.Get.Response[],
	wipStatementId: WorkInProgressStatementId,
) =>
	wipStatements.map((statement) =>
		statement.id === wipStatementId ? { ...statement, underwriterLock: locked } : statement,
	);
